import { showSuccess, showError } from '@/utils/toastHelpers';
import { useCreateDiscount, useUpdateDiscount, useDeleteDiscount } from '@/hooks/useDiscounts';
import { useEntityActions } from '@/hooks/useEntityActions';
import { Discount, DiscountFormData } from './discountsmanager.props';

const emptyForm: DiscountFormData = {
  code: '', raceTypeId: '', discountPercentage: '', discountAmount: '',
  validFrom: '', validTo: '', maxUses: '', active: true,
};

export const useDiscountsActions = (selectedRaceId: string) => {
  const createDiscount = useCreateDiscount(selectedRaceId);
  const updateDiscount = useUpdateDiscount(selectedRaceId);
  const deleteDiscount = useDeleteDiscount(selectedRaceId);

  const crud = useEntityActions<Discount, DiscountFormData>({
    emptyForm,
    deleteMutation: deleteDiscount,
    entityName: 'Кодот за попуст',
  });

  const handleEdit = (discount: Discount) => {
    crud.openEdit(discount, (d) => ({
      code: d.code,
      raceTypeId: d.raceTypeId ? d.raceTypeId.toString() : '',
      discountPercentage: d.discountPercentage?.toString() || '',
      discountAmount: d.discountAmount?.toString() || '',
      validFrom: d.validFrom ? d.validFrom.split('T')[0] : '',
      validTo: d.validTo ? d.validTo.split('T')[0] : '',
      maxUses: d.maxUses?.toString() || '',
      active: d.active,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (
      (crud.formData.discountPercentage && crud.formData.discountAmount) ||
      (!crud.formData.discountPercentage && !crud.formData.discountAmount)
    ) {
      showError({ message: 'Изберете или процент или фиксен износ за попуст.' });
      return;
    }

    try {
      const payload = {
        code: crud.formData.code.toUpperCase(),
        raceTypeId: crud.formData.raceTypeId ? parseInt(String(crud.formData.raceTypeId), 10) : null,
        discountPercentage: crud.formData.discountPercentage ? parseFloat(crud.formData.discountPercentage) : null,
        discountAmount: crud.formData.discountAmount ? parseFloat(crud.formData.discountAmount) : null,
        validFrom: `${crud.formData.validFrom}T00:00:00Z`,
        validTo: `${crud.formData.validTo}T23:59:59Z`,
        maxUses: parseInt(String(crud.formData.maxUses), 10),
        active: crud.formData.active,
      };

      if (crud.editingEntity) {
        await updateDiscount.mutateAsync({ id: crud.editingEntity.id, data: payload });
        showSuccess('Успешно ажурирано', 'Кодот за попуст е успешно ажуриран.');
      } else {
        await createDiscount.mutateAsync(payload);
        showSuccess('Успешно креирано', 'Нов код за попуст е успешно креиран.');
      }

      crud.resetDialog();
    } catch (error) {
      showError(error, 'кодот за попуст');
    }
  };

  return {
    isDialogOpen: crud.isDialogOpen, setIsDialogOpen: crud.setIsDialogOpen,
    editingDiscount: crud.editingEntity, setEditingDiscount: crud.setEditingEntity,
    deleteTarget: crud.deleteTarget, setDeleteTarget: crud.setDeleteTarget,
    formData: crud.formData, setFormData: crud.setFormData,
    handleEdit, handleDelete: crud.handleDelete, confirmDelete: crud.confirmDelete, handleSubmit,
  };
};
